import React from 'react';
import { Input, Textarea } from '@roger/ui-components';
import { Question } from '../types';

interface TextQuestionProps {
  question: Question;
  value: string;
  onChange: (value: string) => void;
}

export const TextQuestion: React.FC<TextQuestionProps> = ({
  question,
  value,
  onChange,
}) => {
  // Determine if this should be a textarea based on question content
  const shouldUseTextarea =
    question.question.toLowerCase().includes('describe') ||
    question.question.toLowerCase().includes('explain') ||
    question.question.toLowerCase().includes('details') ||
    question.question.toLowerCase().includes('comments');

  return (
    <div className='space-y-2'>
      <label className='text-sm font-semibold text-foreground block'>
        {question.question || question.description}
      </label>

      {shouldUseTextarea ? (
        <Textarea
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          className='w-full min-h-[72px]'
          textareaSize='default'
          placeholder='Enter response...'
        />
      ) : (
        <Input
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          placeholder='Enter response...'
          inputSize='default'
          className='w-full'
        />
      )}
    </div>
  );
};
